import { Box, Grid, Typography, Card, CardMedia } from '@mui/material';
import React from 'react';
import AppleHealth from '../../../images/appleHealth.svg';
import GoogleFit from '../../../images/googleFit.svg';
import { styled } from '@mui/system';
import AddDeviceModal from '../../EditProfile/components/AddDeviceModal';
import DeviceCard from '../../EditProfile/components/DeviceCard';
import PairDeviceCard from '../../EditProfile/components/PairDeviceCard';
import { getUserDevices } from '../../../utils/api';
import { isEmpty } from 'lodash';
import { useQuery } from 'react-query';
import Button from '../../../components/Button';

const SOURCE_LIST = [
  {
    title: 'Apple Health',
    img: AppleHealth,
    download: true,
  },
  {
    title: 'Google Fit',
    img: GoogleFit,
    download: true,
  },
];

const StyledCard = styled(Card)(({ theme }) => ({
  backgroundColor: '#fff',
  borderRadius: '16px',
  display: 'flex',
  justifyContent: 'space-between',
  padding: 15,
  marginBottom: 2,
  boxShadow: 'none',
}));

const StyledCardMedia = styled(CardMedia)({
  width: '60px',
  height: '60px',
  borderRadius: '16px',
  overflow: 'hidden',
  border: '1px solid rgba(229, 229, 234, 1)',
  objectFit: 'contain',
  backgroundColor: '#fff',
});

const Integrations = ({ user, recipient }) => {
  const [deviceModal, setAddDeviceModal] = React.useState(false);
  const handleRedirectApp = () => {
    window.open('https://can.co/');
  };

  const {
    data: devices,
    isLoading,
    refetch,
  } = useQuery(
    ['getUserDevices'],
    () => getUserDevices({ userId: user?._id || user?.id, selectedRecipient: recipient?._id }),
    {
      retry: false,
      cacheTime: 0,
    },
  );

  return (
    <>
      <Grid direction={'row'} container>
        <Grid sm={12} md={6} lg={6}>
          {isEmpty(devices?.data[0]) ? (
            <PairDeviceCard setAddDeviceModal={() => setAddDeviceModal(true)} />
          ) : (
            <DeviceCard device={devices?.data || null} user={recipient} cr={true} />
          )}
        </Grid>
        <Grid sm={12} md={6} lg={6}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {SOURCE_LIST.map((item) => (
              <StyledCard>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                  <StyledCardMedia component="img" image={item.img} alt="Apple Health" />
                  <Typography
                    variant="h6"
                    sx={{
                      fontFamily: "'Roboto', Helvetica",
                      fontWeight: 500,
                      color: 'rgba(29, 29, 31, 1)',
                    }}
                  >
                    {item?.title}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                  <Button onClick={handleRedirectApp} text="Download" bg="light" />
                </Box>
              </StyledCard>
            ))}
          </Box>
        </Grid>
      </Grid>
      <AddDeviceModal
        show={deviceModal}
        onClose={() => setAddDeviceModal(false)}
        refetch={refetch}
        recipient={recipient}
        cr={true}
        refetchRecipient={refetch}
      />
    </>
  );
};

export default Integrations;
